module.exports = __webpack_public_path__ + "img/picture-10.68648b36.png";